module.exports = __webpack_public_path__ + "static/media/22.0ea4fae0.jpeg";